export default __webpack_public_path__ + "static/media/wyndham2.365f4962.png";